import '../style.scss'
import { useEffect, useState } from "react"
import { 
    AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer,
    FlexRow, Form, FormGroup, SidePopupContainer, FixedContainer
} from "src/style"
import { CallScheduleSummary, CallSheduleTime } from 'src/popup'


export const Call: React.FC<any> = ({close}) => {
    const [navPosition, setNavPosition] = useState(0)
    const [input, setInput] = useState({serviceType: ''})
    const [showCallDate, setShowCallDate] = useState(false)
    const [isScheduleSummary, setIsScheduleSummary] = useState(false)
    
    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => { document.body.style.overflow = 'auto' }
    }, [])
    
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            { (!showCallDate && !isScheduleSummary) &&
                <FixedContainer 
                    className="service-request-container" 
                    zIndex="9" radius="0.8" bgColor="#ffffff"
                    topPadding="1.5" width='56.6' height='65' hUnit='%'
                >
                    <Form style={{height: '100%'}}>
                        <CustomContainer 
                            height="85" hUnit="%" padding="2.5" overflow="auto" topPadding="1"
                        >
                            <CustomContainer justifyContent="space-between" bottomMargin="4">
                                <AppLabel textSize="2" fontWeight="600" color='#27272E'>Call Ridwan</AppLabel>
                                <AppText width='31.4' textSize='1.2' topMargin='0.7'>
                                    Put a call through to James right away or schedule a call for a particular day. 
                                </AppText>
                            </CustomContainer>
                            <CustomContainer 
                                height="2.7" topMargin="2.5" bottomMargin="3"
                                style={{borderBottom: '1px solid #EDF2F7'}}
                            >
                                <AbsoluteContainer width='100' sizeUnit='%' bottom="0" left={`${navPosition}`}>
                                    <CustomContainer bgColor="#4C6FFF" width="50" sizeUnit='%' height="0.3" />
                                </AbsoluteContainer>
                                <FlexRow gap="3.5">
                                    <AppSpan 
                                        color={navPosition === 0 ? "#1A202C" : "#A0AEC0"}
                                        fontWeight={navPosition === 0 ? "600" : "400"}
                                        textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                        width='50' sizeUnit='%' align='center'
                                        onClick={() => setNavPosition(0)}
                                    >
                                        Call now
                                    </AppSpan>
                                    <AppSpan 
                                        color={navPosition === 25.9 ? "#1A202C" : "#A0AEC0"}
                                        fontWeight={navPosition === 25.9 ? "600" : "400"}
                                        textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                        width='50' sizeUnit='%' align='center'
                                        onClick={() => setNavPosition(25.9)}
                                    >
                                        Schedule call
                                    </AppSpan>
                                </FlexRow>
                            </CustomContainer>
                            <FormGroup bottomMargin="1.5">
                                <label>Reason for call</label>
                                <input 
                                    placeholder='Enter reason here'
                                    name='reason'
                                />
                            </FormGroup>
                            <FormGroup bottomMargin="1.5">
                                <label>Agent</label>
                                <input 
                                    placeholder='Enter agent'
                                    name='agent'
                                />
                            </FormGroup>
                            <FormGroup bottomMargin="0">
                                <label>Call summary</label>
                                <textarea />
                            </FormGroup>
                            <AppText color='#4C6FFF' textSize='1' topMargin='0.7' fontWeight='600'>
                                All calls will automatically be recorded for reference purposes.
                            </AppText>
                        </CustomContainer>
                        <AbsoluteContainer bottom='2.5' left='0'>
                            <CustomContainer leftPadding='2.5' rightPadding='2.5'>
                                { navPosition === 0 &&
                                    <Button
                                        width='17.7' borderColor='#4C6FFF' height='4.6'
                                        hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                    >
                                        Make call to Ridwan
                                    </Button>
                                }
                                { navPosition === 25.9 &&
                                    <Button
                                        width='15.4' borderColor='#E4ECF7' height='4.6'
                                        hoverBgColor='#4AAE8C' hoverColor='#ffffff'
                                        bgColor="#E4ECF7" color="#505780"
                                        onClick={() => setShowCallDate(true)}
                                    >
                                        Set date for call
                                    </Button>
                                }
                            </CustomContainer>
                        </AbsoluteContainer>
                    </Form>
                </FixedContainer>
            }
            { showCallDate &&
                <CallSheduleTime
                    close={() => setShowCallDate(false)}
                    showSummary={() => {
                        setShowCallDate(false)
                        setIsScheduleSummary(true)
                    }} 
                />
            }
            { isScheduleSummary &&
                <CallScheduleSummary 
                    close={close}
                />
            }
        </>
    )
}